module.exports = __webpack_public_path__ + "img/gmail-logo.9dbc79da.svg";